module.exports = __webpack_public_path__ + "media/images/teams-f7baa5a96932343bc5c16db9d4b670b9.svg";